import { render, staticRenderFns } from "./ZoxaLogo.vue?vue&type=template&id=b3abcfcc&scoped=true&"
import script from "./ZoxaLogo.vue?vue&type=script&lang=js&"
export * from "./ZoxaLogo.vue?vue&type=script&lang=js&"
import style0 from "./ZoxaLogo.vue?vue&type=style&index=0&id=b3abcfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3abcfcc",
  null
  
)

export default component.exports